import gql from "graphql-tag";

export default gql`
  query GetCompanySites($id: ID!) {
    allSites(filter: { company: { id: $id } }) {
      id
      name
      physicalAddress
      region
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Queries/GetCompanySites.ts